import color from './color';
import highEmphasis from './high-emphasis';
import mediumEmphasis from './medium-emphasis';
import disabledEmphasis from './disabled-emphasis';

export default {
  color,
  highEmphasis,
  mediumEmphasis,
  disabledEmphasis,
};
